import React, { useState } from "react";
// import Notifications from "./Comman/Notifications";
import Notifications from "../Admin-Dashboard-Component/Comman/Notifications"
import { FiUsers, FiBookOpen, FiAlertCircle } from "react-icons/fi";

const initialAdminNotifications = [
  {
    id: 1,
    type: "student",
    message: "New student registered: Janhavi Patil",
    time: "2 minutes ago",
    read: false,
    icon: <FiUsers />,
  },
  {
    id: 2,
    type: "exam",
    message: "New exam uploaded: Physics Midterm",
    time: "1 hour ago",
    read: false,
    icon: <FiBookOpen />,
  },
  {
    id: 3,
    type: "alert",
    message: "5 students have been inactive for 7 days",
    time: "Yesterday",
    read: true,
    icon: <FiAlertCircle />,
  },
];

const AdminNotifications = () => {
  const [notifications, setNotifications] = useState(initialAdminNotifications);

  const handleMarkAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const handleMarkAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  return (
    <Notifications
      title="Admin Notifications"
      notifications={notifications}
      onMarkAllAsRead={handleMarkAllAsRead}
      onMarkAsRead={handleMarkAsRead}
    />
  );
};

export default AdminNotifications;
